import type {
  IQuickFilter,
  QuickFilterQueryClause,
} from "../../components/Organismos/Table/FilteredTable.types";
import type { DropDownOptionBase } from "../../components/staff/DropDownMultiple";

export const WSG_STAFF_FIRM_OPTIONS: DropDownOptionBase[] = [
  { id: "6ed82f4e-6b67-407f-a698-05281b24095a", name: "World Services Group" },
  { id: "430be9f8-c9be-4f62-aec1-91e0596799b8", name: "Test Demo" },
];

export const REGISTRATION_NOT_CANCELLED_QUERY: Record<
  string,
  QuickFilterQueryClause
> = {
  status: { value: "cancelled", comparisonType: "NOT_EQUAL" },
};

export const REGISTRATION_NOT_STAFF_QUERY: Record<string, QuickFilterQueryClause> =
  {
    attendeeType: { value: "staff", comparisonType: "NOT_EQUAL" },
    ...REGISTRATION_NOT_CANCELLED_QUERY,
  };

export const REGISTRATION_ALL_ATTENDEES_QUICK_FILTER: IQuickFilter = {
  key: "allAttendees",
  label: "All attendees",
  hiddenQuery: REGISTRATION_NOT_STAFF_QUERY,
};

export const REGISTRATION_WSG_STAFF_QUICK_FILTER: IQuickFilter = {
  key: "wsgStaff",
  label: "WSG Staff",
  panelValues: { Firm: WSG_STAFF_FIRM_OPTIONS },
  hiddenQuery: REGISTRATION_NOT_CANCELLED_QUERY,
};

export const EVENT_ATTENDEES_PARTICIPANTS_QUICK_FILTER: IQuickFilter = {
  key: "participants",
  label: "All Participants",
  hiddenQuery: REGISTRATION_NOT_STAFF_QUERY,
};

export const SPECIAL_EVENT_FILTER_OPTION: DropDownOptionBase = {
  id: "hasSpecialEvent",
  name: "Special Event",
};

export const EVENT_ATTENDEES_SPECIAL_EVENTS_QUICK_FILTER: IQuickFilter = {
  key: "specialEvents",
  label: "All Special Events",
  panelValues: { "Special Event": [SPECIAL_EVENT_FILTER_OPTION] },
  hiddenQuery: {
    ...REGISTRATION_NOT_CANCELLED_QUERY,
  },
};

export const EVENT_ATTENDEES_CANCELLED_QUICK_FILTER: IQuickFilter = {
  key: "cancelled",
  label: "Cancelled",
  panelValues: { Status: [{ id: "cancelled", name: "Cancelled" }] },
};
